export default "__VITE_ASSET__D2opqtW5__"